import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface MobileSafetyConfirmOtherUserTemplateState {
  /**
   * 宛先グループ
   * import { SafetyConfirmTargetMessageGroupModalModel } from "@/mobile/components/modals/SafetyConfirmTargetMessageGroupModal.vue";
   * したいが、エラーになるのでanyで代用
   */
  groupTargets: Array<any>;
  /** 冒頭文 */
  openingSentence: string;
  /** 質問リスト */
  confirms: Array<any>;
  /** 更新日時 */
  updated: number | null;
  /** 値が格納してあるか */
  exist: boolean;
}

/**
 * ### MobileSafetyConfirmOtherUserTemplate store
 *
 * - store
 *   - 安否確認事前設定(施設関係者)画面の入力情報を保持する
 * - action, mutation
 *   - 安否確認事前設定(施設関係者)画面の入力情報を格納する
 */
@Module({ name: "mobileSafetyConfirmOtherUserTemplate" })
export default class MobileSafetyConfirmOtherUserTemplate extends VuexModule implements MobileSafetyConfirmOtherUserTemplateState {
  groupTargets: Array<any> = [];
  openingSentence = "";
  confirms = [];
  updated = null;
  exist = false;

  /** stateのgetters */
  get mobileSafetyConfirmOtherUserTemplateState(): MobileSafetyConfirmOtherUserTemplateState {
    const state: MobileSafetyConfirmOtherUserTemplateState = {
      groupTargets: this.groupTargets,
      openingSentence: this.openingSentence,
      confirms: this.confirms,
      updated: this.updated,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILE_SAFETY_CONFIRM_OTHER_USER_TEMPLATE(state: MobileSafetyConfirmOtherUserTemplateState) {
    this.groupTargets = state.groupTargets as any;
    this.openingSentence = state.openingSentence;
    this.confirms = state.confirms as any;
    this.updated = state.updated as any;
    this.exist = true;
    return;
  }

  @Mutation
  private RESET_MOBILE_SAFETY_CONFIRM_OTHER_USER_TEMPLATE() {
    this.groupTargets = [];
    this.openingSentence = "";
    this.confirms = [];
    this.updated = null;
    this.exist = false;
    return;
  }

  /**
   * ### 安否確認新規作成画面の入力情報を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileSafetyConfirmOtherUserTemplateState(payload: { state: MobileSafetyConfirmOtherUserTemplateState }): void {
    this.SET_MOBILE_SAFETY_CONFIRM_OTHER_USER_TEMPLATE(payload.state);
    return;
  }

  /**
   * ### 安否確認新規作成画面の入力情報を初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileSafetyConfirmOtherUserTemplateState(): void {
    this.RESET_MOBILE_SAFETY_CONFIRM_OTHER_USER_TEMPLATE();
    return;
  }
}
